import { Dialog, DialogPanel } from "@headlessui/react";
import { motion } from "motion/react";

/** Props Interface */
interface PDFViewerProps {
	isOpen: boolean;
	onClose: () => void;
	url: string;
}

export function PDFViewer({ isOpen, onClose, url }: PDFViewerProps) {
	/** Render */
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			className="relative z-[501]"
		>
			<div className="fixed inset-0 flex w-screen items-center justify-center p-4">
				<DialogPanel className="w-max h-[80vh]">
					<div className="h-[80vh] w-[80vw] relative overflow-hidden rounded-xl shadow-xl">
						<motion.object
							initial={{ opacity: 0, scale: 0.95 }}
							animate={{ opacity: 1, scale: 1 }}
							exit={{ opacity: 0, scale: 0.95 }}
							data={`${url}#view=FitWidth`}
							type="application/pdf"
							width="100%"
							height="100%"
						>
							<p>Your browser does not support PDFs.</p>
						</motion.object>
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	);
}
